module.exports = __webpack_public_path__ + "static/media/notebook.1032bd96.svg";